import { render, staticRenderFns } from "./meetingDetails.vue?vue&type=template&id=46ba004a&scoped=true&"
import script from "./meetingDetails.vue?vue&type=script&lang=js&"
export * from "./meetingDetails.vue?vue&type=script&lang=js&"
import style0 from "./meetingDetails.vue?vue&type=style&index=0&id=46ba004a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba004a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
